import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import Template from './template';
import { MyProfile } from 'components';

import { apiGetUserProfile } from 'api/ZimssaAPI';
import { getServiceType } from 'commons/ZimssaHelper';
import { useApiRequest } from 'hooks';
import { PartnerAuthState } from 'stores/PartnerAuthStore/index';
import { PAGE_MY_PROFILE_TITLE } from 'commons/ZimssaString';

function MyProfileView(): React.ReactElement {
    const { serviceType } = useParams<{ serviceType: string }>();
    const { partnerUserIdx, service } = useContext(PartnerAuthState);
    const serviceIdx = service.find((item) => item.serviceType === getServiceType(serviceType))?.serviceIdx;
    const [fetchResult, fetchProfile] = useApiRequest<any>(apiGetUserProfile);
    const [userProfile, setUserProfile] = useState<IUserRegisterForm>(defaultFormState);

    useEffect(() => {
        if (serviceIdx) {
            fetchProfile({
                type: 'REQUEST',
                body: [partnerUserIdx, serviceType, serviceIdx],
            });
        }
    }, [fetchProfile, partnerUserIdx, serviceIdx, serviceType]);

    useEffect(() => {
        const { result, data } = fetchResult;
        if (result === 'success' && data) {

            setUserProfile({
                profileImage: data.profileImage,
                name: data.name,
                phone: data.phone,
                isOwner: data.isOwner,
                birthday: data.birthday,
            });
        } else {
        }
    }, [fetchResult]);

    const myProfileProps = {
        profileImage: userProfile.profileImage,
        name: userProfile.name,
        phone: userProfile.phone,
        isOwner: userProfile.isOwner,
        birthday: userProfile.birthday,
    };

    return (
        <Template title={PAGE_MY_PROFILE_TITLE}>
            <MyProfile {...myProfileProps} />
        </Template>
    );
}

export default MyProfileView;

const defaultFormState: IUserRegisterForm = {
    profileImage: '',
    name: '',
    phone: '',
    birthday: '',
    isOwner: false,
};

interface IUserRegisterForm {
    profileImage: string;
    name: string;
    phone: string;
    birthday: string;
    isOwner: boolean;
}
